var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "main-container",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-img', {
    staticClass: "hero-image",
    style: {
      height: ("calc(100vh - " + (_vm.$vuetify.application.top) + "px + 100px)"),
      top: '50px'
    },
    attrs: {
      "cover": "",
      "position": "center center",
      "src": "https://media.eipl.org/site/images/pages/makerlab/makerlab-room-1.jpg"
    }
  }), _c('page-header', {
    attrs: {
      "autoHide": false,
      "backgroundColor": "#aea096",
      "chipItems": _vm.chipItems,
      "titleText": "MAKER LAB",
      "titleColor": _vm.$vuetify.theme.themes.light.primary
    },
    on: {
      "input": _vm.onChipChange
    },
    model: {
      value: _vm.chipItemSelected,
      callback: function ($$v) {
        _vm.chipItemSelected = $$v;
      },
      expression: "chipItemSelected"
    }
  }), _c('v-container', {
    staticClass: "d-flex flex-column transparent align-center px-4",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "start",
      "align-contet": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-column align-center justify-center pt-0 mb-10",
    staticStyle: {
      "margin-top": "34vh"
    },
    attrs: {
      "id": "policies",
      "cols": "12",
      "md": "10",
      "lg": "7"
    }
  }, [_c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "rounded": "lg",
      "width": "100%"
    }
  }, [_c('v-card-text', [_c('v-sheet', {
    staticClass: "d-flex flex-row flex-wrap align-center align-sm-start justify-space-around"
  }, [_c('p', {
    staticClass: "text-h4 blue--text font-weight-bold mb-0 mx-1 mt-4"
  }, [_vm._v(" INVENT ")]), _c('p', {
    staticClass: "text-h4 green--text font-weight-bold mb-0 mx-1 mt-4"
  }, [_vm._v(" BUILD ")]), _c('p', {
    staticClass: "text-h4 orange--text font-weight-bold mb-0 mx-1 mt-4"
  }, [_vm._v(" SHARE ")])]), _c('p', {
    staticClass: "text-h6 primary--text mt-14"
  }, [_vm._v(" The East Islip Public Library (EIPL) Maker Lab is an innovative, creative space that provides library patrons with equipment and software to create personal projects, learn new skills, and explore their interests. ")]), _c('p', {
    staticClass: "text-body-1 primary--text mt-5"
  }, [_vm._v(" Use of the Maker Lab is reserved for EIPL patrons with a library card in good standing. "), _c('br'), _vm._v(" Drop-in visits are allowed but are subject to staff availability, appointments, and scheduled programs. "), _c('br'), _vm._v(" Appointments to use the equipment are recommended and can be made by visiting or calling the reference desk (631-581-9200 ext. 5). ")])], 1), _c('v-card-actions', {
    staticClass: "d-flex flex-wrap justify-space-between"
  }, [_c('phone-button', {
    staticClass: "ma-2"
  }), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-document")]), _vm._v("MAKER LAB POLICY")], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12",
      "md": "10",
      "lg": "7",
      "xl": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "id": "equipment",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "primary secondary--text text-h5 font-weight-bold break-word"
  }, [_vm._v("EQUIPMENT")]), _c('v-card-text', {
    staticClass: "primary--text"
  }, [_c('p', {
    staticClass: "text-h6 primary--text px-8 my-12"
  }, [_vm._v(" The EIPL Maker Lab provides the tools, equipment, and training that allow people to create all kinds of projects. "), _c('br'), _vm._v(" See some of the available equipment below. ")]), _c('v-sheet', {
    staticClass: "pb-10 mx-auto"
  }, _vm._l(_vm.equipment, function (item) {
    return _c('basic-card', {
      key: item.id,
      staticClass: "mt-4",
      attrs: {
        "item": item
      }
    });
  }), 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "id": "materials-pricing",
      "cols": "12",
      "md": "10",
      "lg": "7",
      "xl": "8"
    }
  }, [_c('material-price-card')], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }